// extracted by mini-css-extract-plugin
module.exports = {"root":"PlasmicFooter2_root__5PU8_","freeBox":"PlasmicFooter2_freeBox__1wd2q","slotTargetText":"PlasmicFooter2_slotTargetText__1DtYH"};